import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import '../../Styles/Dashboard.scss';
import Dashboard__ChartLegend from './Dashboard__ChartLegend';
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer
  } from "recharts";
  


export default function Dashboard__LineAreaChart(props) {
    const theme = useTheme();
    const data = [
        
        
        {
          name: "12:00",
          uv: 200,
          pv: 9800,
          amt: 2290
        },
        {
          name: "15:00",
          uv: 270,
          pv: 3908,
          amt: 2000
        },
        
        {
          name: "21:00",
          uv: 239,
          pv: 3800,
          amt: 2500
        },
        {
          name: "24:00",
          uv: 349,
          pv: 4300,
          amt: 2100
        }
      ];
      
    return (
        <React.Fragment>
            <div className="dashboard__chart-wrapper">
              <div className="dashboard__chart-title">Orders by hour:</div>
              <Dashboard__ChartLegend></Dashboard__ChartLegend>


            <ResponsiveContainer width="100%" height={200}>
            
            <AreaChart
          
        width={500}
        height={400}
        data={data}
        margin={{
          top: 10,
          right: 1,
          left: -20,
          bottom: 0
        }}
      >
        <XAxis dataKey="name" />
        <YAxis></YAxis>
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip />
        <Area type="monotone" dataKey="uv" stroke='#5dbcd2' fill='#5dbcd2' />
      </AreaChart>
      </ResponsiveContainer>
      </div>
        </React.Fragment>
    );
}